import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/axelerate-logo-purple.svg'


const _hoisted_1 = { class: "bg-background min-h-screen" }
const _hoisted_2 = { class: "flex flex-col justify-center items-center min-h-screen" }
const _hoisted_3 = { class: "flex flex-col bg-white shadow rounded-2xl w-1/2 xl:w-1/3 p-14" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-2/5"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-2xl" }, "Login to Axelerate", -1)
const _hoisted_6 = { class: "flex flex-col pt-10" }
const _hoisted_7 = { class: "mt-4" }
const _hoisted_8 = { class: "flex flex-row pt-10 items-center justify-between" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "checkbox",
    class: "rounded bg-gray-300 border-0 text-primary focus:outline-none focus:ring-0 focus:ring-transparent"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 pl-2" }, "Remember me")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "flex pt-10" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "w-full text-white bg-primary rounded-full py-4"
  }, " Log In ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
          class: "flex flex-col pt-10"
        }, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _createVNode(_component_TextField, {
                modelValue: _ctx.email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                label: "Email",
                typeInput: "email",
                name: "email"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_TextField, {
                modelValue: _ctx.password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                label: "Password",
                typeInput: "password",
                name: "password"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/forgot-password'))),
                class: "text-primary font-medium"
              }, " Forgot password? ")
            ])
          ]),
          _hoisted_10,
          _createTextVNode(" " + _toDisplayString(_ctx.loginError), 1)
        ], 32)
      ])
    ])
  ]))
}